import _get from 'lodash/get';
export default class Utils {
    static format(path, attributes) {
        return path.replace(/(?:\{([?]?)([^}]+)\})/ig, (match, optional, attribute) => {
            return _get(attributes, attribute, optional == '?' ? '' : match).toString();
        });
    }
}
//# sourceMappingURL=utils.js.map